import React from 'react';
import { BookOpenIcon, CalendarIcon, CheckCircleIcon, ClockIcon, MonitorIcon, UserIcon } from 'lucide-react';
import { WebinarLink } from './WebinarLink';
export const WebinarDetails = ({
  openModal
}) => {
  const replaceWebinarWithLink = text => {
    const parts = text.split(/(\bwebinar\b)/i);
    return parts.map((part, index) => {
      if (part.toLowerCase() === 'webinar') {
        return <WebinarLink key={index} onClick={openModal} data-id="element-324">
            webinar
          </WebinarLink>;
      }
      return part;
    });
  };
  return <section className="mb-10" data-id="element-325">
      <h2 className="text-xl font-bold text-blue-800 mb-4 flex items-center" data-id="element-326">
        <UserIcon className="w-6 h-6 mr-2 text-blue-600" data-id="element-327" />
        De expert achter de 90-minuten transformatie
      </h2>
      <div className="flex items-start mb-6" data-id="element-328">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kJ5b6tBbH8hDNt52JG84mT/Scherm%C2%ADafbeelding_2025-08-15_om_15.44.02.png" alt="Amee de Bruijn" className="w-24 h-24 rounded-full object-cover mr-4 flex-shrink-0" data-id="element-329" />
        <div data-id="element-330">
          <p className="mb-4 leading-relaxed" data-id="element-331">
            Amee de Bruijn, gediplomeerd hondengedragsconsultant niveau 5, heeft
            het webinar ontwikkeld nadat ze zag hoe veel frustratie ontstaat
            door simpele misverstanden tussen honden en hun baasjes.
          </p>
          <p className="mb-4 leading-relaxed" data-id="element-332">
            "Als je begrijpt dat je hond al die tijd probeerde met je te
            communiceren, verandert je hele relatie. En die verandering wil ik
            elke hondeneigenaar gunnen."
          </p>
          <p className="leading-relaxed" data-id="element-333">
            "Mensen vragen me altijd waarom ik deze kennis gratis deel," zegt
            Amee. "Het antwoord is simpel: omdat het basisrecht zou moeten zijn
            om je hond te begrijpen."
          </p>
        </div>
      </div>
      <h2 className="text-xl font-bold text-blue-800 mb-4 flex items-center" data-id="element-334">
        <MonitorIcon className="w-6 h-6 mr-2 text-blue-600" data-id="element-335" />
        Wat er in die 90 minuten precies gebeurt
      </h2>
      <div className="space-y-4 mb-8" data-id="element-336">
        <div className="flex" data-id="element-337">
          <div className="bg-blue-600 text-white rounded-full min-w-8 h-8 flex items-center justify-center font-bold mr-3" data-id="element-338">
            1
          </div>
          <div data-id="element-339">
            <h4 className="font-bold" data-id="element-340">
              Minuut 1-15: Waarom dominantie averechts werkt
            </h4>
            <p className="text-sm text-gray-700" data-id="element-341">
              Amee legt uit waarom straffen en dominant gedrag vaak het
              tegengestelde effect heeft van wat je wilt bereiken, en hoe dit
              spanning creëert in plaats van samenwerking.
            </p>
          </div>
        </div>
        <div className="flex" data-id="element-342">
          <div className="bg-blue-600 text-white rounded-full min-w-8 h-8 flex items-center justify-center font-bold mr-3" data-id="element-343">
            2
          </div>
          <div data-id="element-344">
            <h4 className="font-bold" data-id="element-345">
              Minuut 16-30: Hoe honden natuurlijk communiceren
            </h4>
            <p className="text-sm text-gray-700" data-id="element-346">
              Je ontdekt hoe honden in de natuur onderling communiceren en welke
              signalen ze gebruiken om met elkaar en hun omgeving te "praten".
            </p>
          </div>
        </div>
        <div className="flex" data-id="element-347">
          <div className="bg-blue-600 text-white rounded-full min-w-8 h-8 flex items-center justify-center font-bold mr-3" data-id="element-348">
            3
          </div>
          <div data-id="element-349">
            <h4 className="font-bold" data-id="element-350">
              Minuut 31-45: Signalen herkennen en interpreteren
            </h4>
            <p className="text-sm text-gray-700" data-id="element-351">
              Je leert de belangrijkste lichaamstaal-signalen die elke hond
              gebruikt, en wat ze werkelijk betekenen in verschillende
              situaties.
            </p>
          </div>
        </div>
        <div className="flex" data-id="element-352">
          <div className="bg-blue-600 text-white rounded-full min-w-8 h-8 flex items-center justify-center font-bold mr-3" data-id="element-353">
            4
          </div>
          <div data-id="element-354">
            <h4 className="font-bold" data-id="element-355">Minuut 45-60: In hun taal terugpraten</h4>
            <p className="text-sm text-gray-700" data-id="element-356">
              Hoe je terug communiceert in hun taal en wat dit betekent voor
              jullie dagelijkse samenwerking.
            </p>
          </div>
        </div>
        <div className="flex" data-id="element-357">
          <div className="bg-blue-600 text-white rounded-full min-w-8 h-8 flex items-center justify-center font-bold mr-3" data-id="element-358">
            5
          </div>
          <div data-id="element-359">
            <h4 className="font-bold" data-id="element-360">Minuut 60-75: Verrassing</h4>
            <p className="text-sm text-gray-700" data-id="element-361">
              Hier onthuld Amee een verrassing voor mensen die nog meer willen
              leren over honden communicatie en zelf een echte honden
              gedragsexpert willen worden.
            </p>
          </div>
        </div>
        <div className="flex" data-id="element-362">
          <div className="bg-blue-600 text-white rounded-full min-w-8 h-8 flex items-center justify-center font-bold mr-3" data-id="element-363">
            6
          </div>
          <div data-id="element-364">
            <h4 className="font-bold" data-id="element-365">Minuut 75-90: Vraag-en-anwoord</h4>
            <p className="text-sm text-gray-700" data-id="element-366">
              Amee beantwoorden veelgestelde vragen en vragen van deelnemers.
            </p>
          </div>
        </div>
      </div>
      <p className="mb-6 leading-relaxed" data-id="element-367">
        "Het mooie is dat mensen tijdens het webinar al anders leren kijken naar
        het gedrag van hun hond," vertelt Amee. "Ze herkennen plotseling
        signalen die ze altijd zagen maar verkeerd interpreteerden, en begrijpen
        hun hond direct beter."
      </p>
      <div className="bg-blue-50 p-6 rounded-lg mb-8 border border-blue-200" data-id="element-368">
        <div className="flex items-center mb-4" data-id="element-369">
          <CalendarIcon className="w-5 h-5 text-blue-600 mr-2" data-id="element-370" />
          <h3 className="font-bold" data-id="element-371">
            Het volgende {replaceWebinarWithLink('webinar')}
          </h3>
        </div>
        <ul className="space-y-3 mb-6" data-id="element-372">
          <li className="flex items-start" data-id="element-373">
            <CalendarIcon className="w-5 h-5 text-blue-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-374" />
            <div data-id="element-375">
              <span className="font-semibold" data-id="element-376">Datum:</span> vandaag en morgen
            </div>
          </li>
          <li className="flex items-start" data-id="element-377">
            <ClockIcon className="w-5 h-5 text-blue-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-378" />
            <div data-id="element-379">
              <span className="font-semibold" data-id="element-380">Tijd:</span> 10u, 13u, & 20u
            </div>
          </li>
          <li className="flex items-start" data-id="element-381">
            <MonitorIcon className="w-5 h-5 text-blue-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-382" />
            <div data-id="element-383">
              <span className="font-semibold" data-id="element-384">Locatie:</span> Online (link wordt
              na registratie verstuurd)
            </div>
          </li>
          <li className="flex items-start" data-id="element-385">
            <ClockIcon className="w-5 h-5 text-blue-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-386" />
            <div data-id="element-387">
              <span className="font-semibold" data-id="element-388">Duur:</span> 90 minuten
            </div>
          </li>
          <li className="flex items-start" data-id="element-389">
            <CheckCircleIcon className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-390" />
            <div data-id="element-391">
              <span className="font-semibold" data-id="element-392">Kosten:</span> 100% GRATIS
            </div>
          </li>
        </ul>
        <div className="bg-white p-4 rounded-lg border border-blue-200 mb-5" data-id="element-393">
          <p className="font-bold text-blue-800 mb-2" data-id="element-394">Belangrijk:</p>
          <p className="text-blue-800" data-id="element-395">
            Er zijn beperkte plekken beschikbaar per uitzending. Elke maand
            melden zich meer mensen aan, dus reserveer snel je plek!
          </p>
        </div>
        <a href="https://stresslessdogs.nl/mcc-meta-adv2" className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-4 rounded-lg transition duration-200 block text-center" target="_blank" rel="noopener noreferrer" data-id="element-396">
          RESERVEER MIJN PLEK - GRATIS AANMELDEN
        </a>
      </div>
      <div className="w-full mb-6" data-id="element-397">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4q5cC71mhLz2oJ2dhhpDRD/Scherm_afbeelding_2025-08-15_om_15.46.41-min.png" alt="Vrouw wandelt ontspannen met haar hond op een bospad" className="w-full h-auto rounded-lg shadow-md" data-id="element-398" />
        <p className="text-xs text-gray-500 mt-1 text-center italic" data-id="element-399">
          Een stressvrij leven voor je hond. En voor jou.
        </p>
      </div>
      <div className="bg-green-50 p-6 rounded-lg border border-green-200 mb-8" data-id="element-400">
        <h3 className="text-lg font-bold text-green-800 mb-4" data-id="element-401">
          Speciale Bonus Voor Deelnemers:
        </h3>
        <p className="text-green-800 mb-5" data-id="element-402">
          Als bonus ontvangen deelnemers een speciale verrassing die Amee pas
          tijdens het webinar onthult - iets dat liefdevolle baasjes helpt om
          direct hun hond beter te begrijpen.
        </p>
        <ul className="space-y-3 mb-5" data-id="element-403">
          <li className="flex items-start" data-id="element-404">
            <CheckCircleIcon className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-405" />
            <span data-id="element-406">De opname wordt naar alle deelnemers gestuurd</span>
          </li>
          <li className="flex items-start" data-id="element-407">
            <CheckCircleIcon className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-408" />
            <span data-id="element-409">Je kunt deelnemen vanaf je telefoon, tablet of computer</span>
          </li>
          <li className="flex items-start" data-id="element-410">
            <CheckCircleIcon className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-411" />
            <span data-id="element-412">
              Speciale verrassingsbonus tijdens het{' '}
              {replaceWebinarWithLink('webinar')}
            </span>
          </li>
        </ul>
        <a href="https://stresslessdogs.nl/mcc-meta-adv2" className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-4 rounded-lg transition duration-200 block text-center" target="_blank" rel="noopener noreferrer" data-id="element-413">
          JA, IK WIL DEZE BONUSSEN - SCHRIJF ME IN!
        </a>
      </div>
    </section>;
};